var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['', _vm.draggableClasses],attrs:{"draggable":"true"},on:{"drag":_vm.drag,"dragstart":_vm.dragStartPanel,"dragend":_vm.dragEndPanel}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }